import { appConfigAtom } from '@/state/app';
import { useRecoilValue } from 'recoil';
import { detect } from 'detect-browser';
import { walletAtom } from '@/state/wallet';
import WalletModal from '@/components/wallet/WalletModal';

const WalletConnection = () => {
    const appConfig = useRecoilValue(appConfigAtom);
    const walletState = useRecoilValue(walletAtom);
    const browser = detect();
    const showModal = () => {
        if (appConfig.token === 'APTOS' && (browser?.name === 'firefox' || browser?.name === 'edge')) {
            return false;
        } else if (
            (appConfig.token !== 'APTOS' && walletState.selectedAddress) ||
            (appConfig.token === 'APTOS' && walletState.walletType === 'aptos' && walletState.selectedAddress)
        ) {
            return false;
        } else {
            return true;
        }
    };

    return showModal() ? <WalletModal isVisible={true} isClosable={false} onClose={() => {}} /> : null;
};

export default WalletConnection;
